import React, { useState } from 'react';
import clsx from 'clsx';
import { Button, TextButton } from '@wix/design-system';
import { ChevronLeft } from '@wix/wix-ui-icons-common';
import { useOrchestratorNavigation } from '../hooks/useOrchestratorNavigation';
import { useOrchestratorState } from '../hooks/useOrchestratorState';
import styles from './StepLayoutActions.scss';
export function StepLayoutActions(_ref) {
  var _currentStep$params;
  let {
    nextCta,
    backText = 'Back',
    className,
    onNext
  } = _ref;
  const {
    canGoBack,
    back,
    next
  } = useOrchestratorNavigation();
  const {
    currentStep
  } = useOrchestratorState();
  const [isLoading, setIsLoading] = useState(false);
  const isCheckpoint = (currentStep == null || (_currentStep$params = currentStep.params) == null ? void 0 : _currentStep$params.checkpoint) === true;
  const handleNext = async () => {
    if (isLoading) {
      return;
    }
    setIsLoading(true);
    try {
      if (onNext) {
        await onNext();
      } else {
        next();
      }
    } finally {
      setIsLoading(false);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: clsx(styles.root, className)
  }, canGoBack && !isCheckpoint ? /*#__PURE__*/React.createElement(TextButton, {
    skin: "dark",
    prefixIcon: /*#__PURE__*/React.createElement(ChevronLeft, null),
    onClick: back,
    disabled: isLoading
  }, backText) : /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement(Button, {
    disabled: nextCta.disabled || isLoading,
    skin: nextCta.skin,
    priority: nextCta.priority,
    onClick: handleNext
  }, nextCta.text));
}
//# sourceMappingURL=StepLayoutActions.js.map